import { Component, AfterViewInit } from '@angular/core';
import { Router } from '@angular/router';
import { DashboardService } from './services/dashboard/dashbaord.service';

declare const Quill: any;

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.css']
})
export class DashboardEditorComponent implements AfterViewInit {
  file: File | null = null;
  uploading = false;
  message = '';
  imageUrl = '';
  quill: any;
  direction: 'rtl' | 'ltr' = 'ltr';

  constructor(private service: DashboardService, private router: Router) {}

  ngAfterViewInit(): void {
    const lang = this.router.url.split('/')[1];
    this.direction = lang === 'ar' ? 'rtl' : 'ltr';

    this.quill = new Quill('#editor', {
      theme: 'snow'
    });

    this.quill.root.setAttribute('dir', this.direction);
    this.quill.root.setAttribute('lang', lang);
    this.quill.root.setAttribute('style', `text-align: ${this.direction === 'rtl' ? 'right' : 'left'}`);

    this.service.getContent(lang).subscribe({
      next: (res: any) => {
        const data = res.record;
        this.imageUrl = data.imgsrc;
        this.quill.root.innerHTML = data.content;
      },
      error: () => {
        this.message = 'Failed to load content';
      }
    });
  }

  onFileChange(event: any) {
    this.file = event.target.files[0];
  }

  openImage() {
    if (this.imageUrl) {
      window.open(this.imageUrl, '_blank', 'noopener');
    }
  }

  async submit() {
    const contentHtml = this.quill.root.innerHTML;
    const lang = this.direction === 'rtl' ? 'ar' : 'en';

    this.uploading = true;

    let uploadedImageUrl = this.imageUrl;

    if (this.file) {
      const base64 = await this.convertToBase64(this.file);
      const newUrl = await this.service.uploadImage(base64);
      if (!newUrl) {
        this.message = 'Image upload failed';
        this.uploading = false;
        return;
      }
      uploadedImageUrl = newUrl;
    }

    const data = { content: contentHtml, imgsrc: uploadedImageUrl };

    this.service.updateContent(data, lang).subscribe({
      next: () => {
        this.message = 'Updated successfully!';
        this.imageUrl = uploadedImageUrl;
        this.uploading = false;
      },
      error: () => {
        this.message = 'Failed to update JSON.';
        this.uploading = false;
      }
    });
  }

  convertToBase64(file: File): Promise<string> {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = () => {
        const base64 = (reader.result as string).split(',')[1];
        resolve(base64);
      };
      reader.onerror = reject;
      reader.readAsDataURL(file);
    });
  }
}